<template>
  <div :class="cssClasses" :style="containerStyles">
    <Pie
      :id="chartId"
      :data="chartData"
      :options="chartOptions"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
    />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'PieChart',
  components: {
    Pie
  },
  props: {
    chartId: {
      type: String,
      default: 'pie-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },


  data() {
    return {
      chartData: {
        labels: ['Trump', 'Harris', 'Opposition', 'No Vote'],
        datasets: [
          {
            backgroundColor: ['#930000', '#000093', '#009300', '#930093'],
            data: [32.8, 31.8, 1.2, 34.2]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed: {
    containerStyles() {
      return {
        position: 'relative',
        width: `${this.width}px`,
        height: `${this.height}px`,
        ...this.styles
      }
    }
  }
}
</script>
